import { InspectDatapointValueTranscoders } from "./inspect-data-helpers";
import { dateBasedYearHelper, getValue } from "./value-helpers";
import { numberFormatters } from "common";
import { dateFromObject } from "common/date-utils";
import { NumberFormatKind } from "common/types";
import { language } from "language/default";
const fractionDigits = 2;
const percentageGetter = (params) => {
    if (params.colDef.field) {
        const value = getValue(params.data, params.colDef.field);
        if ((value || value === 0) && !isNaN(value)) {
            return Number((value * 100).toFixed(fractionDigits));
        }
    }
    return "";
};
const signedPercentageGetter = (params) => {
    if (params.colDef.field) {
        const value = getValue(params.data, params.colDef.field);
        if ((value || value === 0) && !isNaN(value)) {
            return numberFormatters(value, NumberFormatKind.percent, { signDisplay: "exceptZero" });
        }
    }
    return "";
};
const dateBasedYearGetter = (params) => {
    const { colDef, context } = params;
    if (colDef?.field) {
        const value = params.data[colDef.field];
        return dateBasedYearHelper(value, context);
    }
    return "";
};
const multiplyGetter = (params) => {
    if (params.colDef.field) {
        const value = getValue(params.data, params.colDef.field);
        if ((value || value === 0) && !isNaN(value)) {
            return Number(value.toFixed(fractionDigits));
        }
    }
    return "";
};
const moneyGetter = (params) => {
    if (params.colDef.field) {
        const valueAmount = getValue(params.data, params.colDef.field);
        if (!valueAmount) {
            return "";
        }
        return valueAmount?.value ?? valueAmount?.amount;
    }
    return "";
};
const areaGetter = (params) => {
    const colField = params.colDef.field;
    if (colField && params.data[colField]) {
        const { value, area, unitOfArea } = params.data[colField];
        const valueArea = value ?? area;
        return (valueArea || valueArea === 0) && !isNaN(valueArea)
            ? numberFormatters(valueArea, NumberFormatKind.default, { compactDisplay: "short",
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
                notation: "compact",
                unitOfArea })
            : valueArea;
    }
    return "";
};
const unitGetter = (params) => {
    if (params.colDef.field) {
        const valueUnit = getValue(params.data, params.colDef.field);
        if (!valueUnit) {
            return "";
        }
        return valueUnit?.value ?? valueUnit?.unit;
    }
    return "";
};
const falseValues = [false, "False", "No"];
const trueValues = [true, "True", "Yes"];
const booleanGetter = (params) => {
    if (params?.colDef.field && params.data) {
        const value = getValue(params.data, params.colDef.field);
        if (value === undefined || value === null) {
            return "";
        }
        if (trueValues.includes(value)) {
            return language.en.common.yes;
        }
        else if (falseValues.includes(value)) {
            return language.en.common.no;
        }
    }
    return "";
};
const dateGetter = (params) => {
    const colField = params.colDef.field;
    if (colField && params.data[colField]) {
        return dateFromObject(params.data[colField]);
    }
    return "";
};
const inspectDataGetter = (params) => {
    const colField = params.colDef.field;
    if (colField && params.data && params.data[colField]) {
        const { format, value, valueTranscoder } = params.data[colField] || {};
        if ((format || format === 0) && Number.isFinite(value)) {
            return numberFormatters(Number(value), format);
        }
        if (value && valueTranscoder && InspectDatapointValueTranscoders[valueTranscoder]) {
            return InspectDatapointValueTranscoders[valueTranscoder](value);
        }
        return (value || "").toString();
    }
    return "";
};
export const isTotallessGroupColumn = (params) => {
    if (!params?.node?.group) {
        return false;
    }
    return !(params?.colDef?.field && params?.context?.totals?.[params.colDef.field]);
};
export const linkLabelValueGetter = (params) => {
    const colField = params.colDef.field;
    if (colField && params?.data && (colField in params.data)) {
        return (params.data[colField]?.label ? params.data[colField].label : params.data[colField]) ?? "";
    }
    return "";
};
export { percentageGetter, signedPercentageGetter, multiplyGetter, dateGetter, dateBasedYearGetter, moneyGetter, inspectDataGetter, areaGetter, unitGetter, booleanGetter };
